import { defineStore } from 'pinia'
import { useAgencyStore } from '@/stores/agency'

import { availValidationData, reserveValidationData } from './utl.js'
import axios from '@/plugins/axios'
import avail from './avail.json'
import { options } from 'sanitize-html'

const initialState = () => {
  return {
    ticket: {
      _id: '',
      active: false,
      childrenAllowed: false,
      checkIn: '',
      checkOut: '',
      lowestPrice: 0,
      highestPrice: 0,
      cancelPolicies: [],
      images: [],
      certified: false,
      release: 0,
      name: '',
      description: {},
      place: {},
      comments: '',
      address: '',
      endHour: '',
      startHour: '',
      endHour: '',
      city: '',
      cityName: '',
      category: '',
      bookingCode: '',
      agency: '',
      createdAt: '',
      updatedAt: '',
      fullPrice: 0,
      maxPeople: 0,
      priceNoTaxes: 0
    },
    reserve: {
      bookingInfo: {},
      start: '',
      end: '',
      startHour: '',
      endHour: '',
      companions: [],
      room: {},
      payments: {},
      holder: {},
      price: {
        gross: 0,
        currency: '',
        qty: 0
      },
      bookingCode: '',
      countryCode: '',
      currency: '',
      country: '',
      observations: '',
      comments: '',
      destination: {},
      cancellationPolicies: [],
      options: []
    },
    errors: [],
    payments: {},
    tickets: [],
    rangePrice: [0, 0],
    option_selected: [],
    cancelPolicies: [],
    isQuery: false,
    modal: false,
    police_dialog: false,
    country: '',
    countryCode: '',
    start: '',
    end: '',
    provider_id: '',
    keyword: '',
    destination: {},
    numberOfAdults: 2,
    numberOfChildren: 0,
    totalNumberOfPeople: 2,
    paxes: {
      numberOfPeople: 2,
      children: 0,
      childrenAge: [],
      adults: 2,
      adultsAge: [30, 30]
    },
    version: '2.0.0'
  }
}
export default defineStore('ticketsKudenix', {
  state: () => initialState(),
  actions: {
    async avail() {
      const agencyStore = useAgencyStore()
      let url = `api/ticket/kudenix/avail`

      let response = null

      this.isQuery = false
      this.errors = []

      const test = agencyStore?.mode === 'production' ? false : true
      const start = this.start
      const end = this.end
      const paxes = this.paxes
      const country = this.country
      const countryCode = this.countryCode
      const keyword = this.keyword
      const destination = this.destination
      const numberOfAdults = this.numberOfAdults
      const numberOfChildren = this.numberOfChildren
      const totalNumberOfPeople = this.totalNumberOfPeople
      const provider_id = this.provider_id

      const { adultsAge: adults = [], childrenAge: children = [] } = { ...paxes }

      const errors = availValidationData({
        start,
        end,
        paxes: { adults, children },
        countryCode,
        country,
        keyword,
        destination,
        numberOfAdults,
        numberOfChildren,
        totalNumberOfPeople,
        provider_id
      })

      if (errors.errors) {
        this.errors = errors.data
        return
      }

      const data = {
        countryCode: countryCode,
        keyword: this.keyword,
        provider: this.provider_id,
        providers: [this.provider_id],
        destination: destination?._id,
        start,
        end,
        paxes: { adults, children },
        simulate: false // test
      }

      this.preload = true
      this.tickets = []

      response = await axios.post(`${url}`, data)
      /*
          // Modo sanbox
          response = {data: avail}
        */

      const { success = false, response: ticketsResponse = {} } = { ...response?.data }

      const {
        lowestPrice = 0,
        highestPrice = 0,
        itemsFound = 0,
        expires = 0,
        items = []
      } = { ...ticketsResponse }

      if (success) {
        this.tickets = items
        this.lowestPrice = lowestPrice
        this.highestPrice = highestPrice
        this.expires = expires
        this.itemsFound = expires
        this.rangePrice = [lowestPrice, highestPrice]
        this.isQuery = true
        this.preload = true
      }
    },
    async booking({ isEstimate = false }) {
      const agencyStore = useAgencyStore()

      const url = `api/voucher`
      const bookingCodes = this.reserve.options.map((option) => option.bookingCode)
      const errors = reserveValidationData({
        ...this.reserve,
        bookingCodes
      })

      if (errors.errors) {
        this.errors = errors.data
        return {
          status: false,
          messages: errors.data
        }
      }

      const payments = this.reserve.payments
      payments.client = this.reserve.price.gross
      payments.currency = this.reserve.price.currency

      const data = {
        provider: this.provider_id,
        bookingInfo: this.reserve.bookingInfo,
        start: this.reserve.start,
        end: this.reserve.end,
        startHour: this.reserve?.startHour,
        endHour: this.reserve?.endHour,
        destination: this.reserve.destination,
        client: {
          name: `${this.reserve.holder?.name} ${this.reserve.holder?.surname}`,
          email: `${this.reserve.holder?.email}`,
          address: `${this.reserve.holder?.address}`,
          document: this.reserve.holder?.document,
          documentType: this.reserve.holder?.documentType,
          age: this.reserve.holder?.age,
          country: this.reserve.country,
          city: this.reserve.holder?.city,
          postalCode: this.reserve.holder?.postalCode,
          nationality: this.reserve.country,
          phones: [this.reserve.holder?.phone]
        },
        price: this.reserve.price,
        payments,
        cancellationPolicies: this.reserve.cancellationPolicies,
        country: this.reserve.country,
        bookingCodes,
        companions: this.reserve.companions,
        comments: this.reserve.comments,
        options: this.reserve.options,
        observations: this.reserve.observations,
        type: 'tickets-kudenix',
        integrator: 'kudenix',
        status: 'confirmed',
        mode: agencyStore?.mode,
        isEstimate
      }
      return await axios.post(`${url}`, data)
    },
    startReservation(payload) {
      const {
        companions = [],
        payments = {},
        cancellationPolicies = [],
        bookingInfo = [],
        options = [],
        bookingCode = '',
        start = '',
        end = '',
        fullPrice = '',
        comments = '',
        startHour = '',
        endHour = '',
        ticket = {},
        price = {},
      } = payload

      const countryCode = this.countryCode || ''
      const country = this.country || ''
      const destination = this.destination || {}

      const reserve = {
        ticket,
        start,
        end,
        companions,
        payments,
        countryCode,
        price: this?.ticket.price,
        country,
        destination,
        cancellationPolicies,
        fullPrice,
        bookingCode,
        bookingInfo,
        comments,
        startHour,
        options,
        endHour,
        price,
      }

      this.saveReserve(reserve)

      return {
        error: true,
        message: ''
      }
    },
    async addReserve(payload) {
      let { id, ticket, planCode } = payload

      ticket['id'] = id
      ticket['selectedPlan'] = planCode

      this.reserve = ticket
    },
    saveReserve(payload) {
      const {
        bookingInfo = {},
        start = '',
        end = '',
        endHour = '',
        startHour = '',
        companions = [],
        options = [],
        payments = {},
        holder = {
          name: ``,
          email: '',
          address: ``,
          document: '',
          documentType: '',
          age: '',
          country: '',
          city: '',
          postalCode: '',
          nationality: '',
          phones: []
        },
        countryCode = '',
        bookingCode = '',
        country = '',
        destination = '',
        comments = '',
        price = {},
        cancellationPolicies = []
      } = payload

      this.reserve.bookingInfo = bookingInfo
      this.reserve.start = start
      this.reserve.end = end
      this.reserve.companions = companions
      this.reserve.payments = payments
      this.reserve.price = {
        ...price,
        fullPrice: price.gross,
        currency: price.currency,
        qty: this.ticket?.paxes?.totalNumberOfPeople,
        unitPrice: 0,
      }
      this.reserve.currency = this.ticket.currency
      this.reserve.countryCode = countryCode
      this.reserve.country = country
      this.reserve.destination = destination
      this.reserve.holder = holder
      this.reserve.bookingCode = bookingCode
      this.reserve.comments = comments
      this.reserve.cancellationPolicies = cancellationPolicies
      this.reserve.endHour = endHour
      this.reserve.startHour = startHour
      this.reserve.options = options
    },
    reset() {
      Object.assign(this, defineStore)
    }
  },
  persist: true
})
